import React from "react";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import PropTypes from "prop-types";

/**
 * MuiPickersUtilsProvider component wrapper for date picker utilities.
 * Wraps Material-UI MuiPickersUtilsProvider for consistent imports.
 * 
 * @component
 * @example
 * <MuiPickersUtilsProvider utils={MomentUtils}>
 *   <KeyboardDatePicker />
 * </MuiPickersUtilsProvider>
 */
const MuiPickersUtilsProviderWrapper = ({ children, ...props }) => {
  return <MuiPickersUtilsProvider {...props}>{children}</MuiPickersUtilsProvider>;
};

MuiPickersUtilsProviderWrapper.propTypes = {
  /**
   * The content of the component
   */
  children: PropTypes.node.isRequired,
  /**
   * Utils to be used for date manipulation
   */
  utils: PropTypes.object.isRequired,
};

export default MuiPickersUtilsProviderWrapper;
